import { PlanActionTypes } from "../models/planActions";
import { PLAN_ACCEPTED } from "../types";

export default (data: string): PlanActionTypes => ({
    type: PLAN_ACCEPTED,
    payload: data,
});
